// extracted by mini-css-extract-plugin
export default {"container":"ViewNotification_container__1xp58","fields":"ViewNotification_fields__fM3kG"};